import { Flex, Text } from "@fluentui/react-northstar";
import { getSurveyTypeDisplay } from "@teams/cards";
import { TeamsSurveyTypes } from "@teams/types";
import React from "react";

type Props = {
  type: TeamsSurveyTypes;
};

export const InstallWarning: React.FC<Props> = ({ type }) => {
  return (
    <Flex column gap="gap.medium" hAlign="center">
      <Text
        size="large"
        align="center"
        weight="bold"
        content={`Sorry, Polly must first be installed to this meeting as a tab to use ${getSurveyTypeDisplay(
          type,
          { capitalize: true }
        )}`}
      />

      <Text color="brand" size="large" align="center" weight="bold">
        <a
          style={{ textDecoration: "none" }}
          target="_blank"
          rel="noreferrer"
          href="https://www.polly.ai/help/microsoft-teams/polly-for-teams-meetings-guide"
        >
          Go here to learn more!
        </a>
      </Text>
    </Flex>
  );
};
